// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"47":"6a45747ce00a57b2","3374":"a4897cd84ca2e0dd"}[chunkId] + ".js";
};